import React from 'react'

const Banner = ({ username, brokerName }) => {
  const hasBroker = !!brokerName

  return (
    <div className="signupHeader">
      <h1>Your Owner's Edge account</h1>

      <h3>
        {username}
        {hasBroker && ` at ${brokerName}`}
      </h3>
    </div>
  )
}

export default Banner
